module.exports = __webpack_public_path__ + "media/images/pic/courses/benefit07-41d017b183b9789d4313b1a91b29a9a1.svg";